import type { ComponentType } from 'react';

import { type ITooltipProps } from '@livechat/design-system-react-components';

import { NavigationTooltipType } from 'constants/navigation';
import { useParamSelector } from 'hooks/use-param-selector';
import { getNavigationItemTooltip } from 'store/views/navigation/selectors';

import { HelpDeskAppTooltip } from '../tooltips/HelpDeskAppTooltip';
import { HelpDeskPromoTooltip } from '../tooltips/HelpDeskPromoTooltip';
import { NewAvailabilityTooltip } from '../tooltips/NewAvailabilityTooltip';
import { PrivateSuggestedCannedsTooltip } from '../tooltips/PrivateSuggestedCannedsTooltip';
import { TargetedMessagesTooltip } from '../tooltips/TargetedMessagesTooltip';

interface INavigationTooltip {
  content: ComponentType | null;
  props: Omit<ITooltipProps, 'triggerRenderer'>;
}

const tooltipsMap = new Map([
  [NavigationTooltipType.HelpDeskApp, HelpDeskAppTooltip],
  [NavigationTooltipType.HelpDeskPromo, HelpDeskPromoTooltip],
  [NavigationTooltipType.TargetedMessages, TargetedMessagesTooltip],
  [NavigationTooltipType.NewAvailability, NewAvailabilityTooltip],
  [NavigationTooltipType.PrivateSuggestedCanneds, PrivateSuggestedCannedsTooltip],
]);

export const useNavigationTooltip = (itemId: string): INavigationTooltip | null => {
  const tooltip = useParamSelector(getNavigationItemTooltip, itemId);
  const content = tooltipsMap.get(tooltip?.type) || null;

  if (!tooltip || !content) {
    return null;
  }

  const { kind, show } = tooltip;

  return {
    content,
    props: {
      kind,
      isVisible: show,
      placement: 'right-start' as ITooltipProps['placement'],
      offsetMainAxis: 12,
    },
  };
};
